import { render, staticRenderFns } from "./GoogleSignInButton.vue?vue&type=template&id=667c9cbb&scoped=true"
var script = {}
import style0 from "./GoogleSignInButton.vue?vue&type=style&index=0&id=667c9cbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c9cbb",
  null
  
)

export default component.exports